module.exports = __webpack_public_path__ + "img/cover.f258e9e4.jpg";